<script setup>
    // Parent component modeled after UserData.vue. Handles switching between show and edit.
    // Shows a generic error message if an error is emitted.

    import ContactPersonInfoShow from './ContactPersonInfoShow.vue';
    import ContactPersonInfoEdit from './ContactPersonInfoEdit.vue';
    import { ref } from 'vue';

    const state = ref(0);
    const saveConfirm = ref(0);
    const props = defineProps(['fetchUrl', 'updateUrl', 'userNumber']);
    const saveError = ref(false);
</script>

<template>

    <p v-if="saveConfirm != 0">Daten erfolgreich gespeichert!</p>
    <p v-if="saveError === true">Leider ist ein Fehler passiert. Wir bitten um Entschuldigung.</p>
    <ContactPersonInfoShow
      v-if="state == 0"
      @switch-to-edit="state = 1"
      :fetchUrl="props.fetchUrl"
      :userNumber="props.userNumber" />
    <ContactPersonInfoEdit
      v-if="state == 1"
      @switch-to-show="state = 0"
      @successful-save="saveError = false, saveConfirm = 1"
      @save-error="saveError = true"
      :fetchUrl="props.fetchUrl"
      :updateUrl="props.updateUrl"
      :userNumber="props.userNumber" />

</template>
